import * as React from "react";
import {Component, createElement as h} from "react";

interface P {
    _ref?;
    onWheel;
    component?;
    className?;
    style?;
    href?;
    onScroll?;
    onClick?;
}

interface S {
}

export class ActiveWheel extends Component<P,S> {
    ref;

    render() {
        const {_ref, onWheel, component="div", ...others} = this.props;

        return (
            h(component, {
                ...others,
                ref: (r1 : any) => {
                    _ref && _ref(r1);
                    if (!this.ref && r1) {
                        this.ref = r1;

                        r1.addEventListener("wheel", (e) => onWheel(e), {passive: false});
                    }
                },
            })
        );
    }
}
